import { useEffect, useRef } from 'react';
import Game from './Game';

function Month({ monthData, monthIndex, isAdmin, onScoreUpdate, onPlayerUpdate, scoreDict, gamesPlayedDict, historicalDicts }) {
  const currentMonth = new Date().getMonth();
  const currentDate = new Date().getDate();
  const monthRef = useRef(null);

  useEffect(() => {
    if (currentMonth === monthIndex) {
      monthRef.current.scrollIntoView({ behavior: 'smooth' })
    }
  }, [currentMonth, monthIndex]);

  if (monthData.games.length === 0) {
    return <></>
  }

  return (
      <div className="month" ref={monthRef}>
        <h2 className="month-title">{monthData.month}</h2>
        { monthData.games.map((game, gameIndex) => {
          const gameDay = parseInt(game.date.split('/')[0]);
          const isCurrent = monthIndex === currentMonth && gameDay === currentDate;
          const isPast  = monthIndex < currentMonth || (monthIndex === currentMonth && gameDay < currentDate);
          return (
            <Game
              key={gameIndex}
              date={game.date}
              teams={game.teams}
              score={game.score}
              isCurrent={isCurrent}
              isPast={isPast}
              isAdmin={isAdmin}
              scoreDict={historicalDicts[`${monthIndex}-${gameIndex}`]?.scoreDict || scoreDict}
              gamesPlayedDict={historicalDicts[`${monthIndex}-${gameIndex}`]?.gamesPlayedDict || gamesPlayedDict}
              onScoreUpdate={(playerIndex, newScore) =>
                onScoreUpdate(monthIndex, gameIndex, playerIndex, newScore)
              }
              onPlayerUpdate={(playerIndex, newName) =>
                onPlayerUpdate(monthIndex, gameIndex, playerIndex, newName)
              }
            />
          );
        }) }
      </div>
  );
}

export default Month;